import React, { useState } from 'react'
import Popover from '@mui/material/Popover'
import {
  BusinessOnboardingBodyPlanSelectorArrow,
  BusinessOnboardingBodyPlanSelectorText,
  BusinessOnboardingInput,
  BusinessOnboardingSingleSelectContainer,
  BusinessOnboardingSingleSelectOption,
  BusinessOnboardingSingleSelectOptionsContainer,
} from './BusinessOnboardingStyles'
import { getPriceStringBusinessPlan } from 'src/shared/utils/businessPlanDisplay'
import caretPurpleDownIcon from 'src/assets/caret_purple_down.png'

export const BusinessOnboardingInputComponent = ({ type, title, enteredValue, setterFunction }) => {
  return (
    <>
      <div>{title}</div>
      <BusinessOnboardingInput
        type={type}
        value={enteredValue}
        onChange={(event) => setterFunction(event.target.value)}
      />
    </>
  )
}

export const BusinessOnboardingSingleSelect = ({
  idForSelection,
  title,
  options,
  selectedOptionId,
  setterFunction,
  showPrices,
  currency,
}) => {
  const [anchorForSingleSelectPopover, setAnchorForSingleSelectPopover] = useState()

  const handleOpenClick = (event) => {
    setAnchorForSingleSelectPopover(event.currentTarget)
  }
  const handleCloseClick = () => {
    setAnchorForSingleSelectPopover(null)
  }

  const selectionOpen = Boolean(anchorForSingleSelectPopover)
  const idForPopover = selectionOpen ? idForSelection : undefined

  return (
    <>
      <div>{title}</div>
      <BusinessOnboardingSingleSelectContainer onClick={(event) => handleOpenClick(event)}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <BusinessOnboardingBodyPlanSelectorText>
            {options?.find((item) => item?.id === selectedOptionId)?.title}
          </BusinessOnboardingBodyPlanSelectorText>
          {showPrices && (
            <div>
              <BusinessOnboardingBodyPlanSelectorText bold gray>
                {getPriceStringBusinessPlan(
                  currency,
                  options?.find((item) => item?.id === selectedOptionId)?.pricePEPM,
                )}
              </BusinessOnboardingBodyPlanSelectorText>
              <BusinessOnboardingBodyPlanSelectorText bold green>
                {options?.find((item) => item?.id === selectedOptionId)?.bestValue && 'Best Value'}
              </BusinessOnboardingBodyPlanSelectorText>
            </div>
          )}
        </div>
        <BusinessOnboardingBodyPlanSelectorArrow
          menuOpen={anchorForSingleSelectPopover}
          src={caretPurpleDownIcon}
        />
      </BusinessOnboardingSingleSelectContainer>
      <Popover
        id={idForPopover}
        open={selectionOpen}
        anchorEl={anchorForSingleSelectPopover}
        onClose={handleCloseClick}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <BusinessOnboardingSingleSelectOptionsContainer considerPadding={showPrices}>
          {options?.map((item) => (
            <BusinessOnboardingSingleSelectOption
              key={item?.id}
              selected={selectedOptionId === item?.id}
              onClick={() => {
                setterFunction(item?.id)
                handleCloseClick()
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <BusinessOnboardingBodyPlanSelectorText>
                  {item?.title}
                </BusinessOnboardingBodyPlanSelectorText>
                {showPrices && (
                  <div>
                    <BusinessOnboardingBodyPlanSelectorText bold gray>
                      {getPriceStringBusinessPlan(currency, item?.pricePEPM)}
                    </BusinessOnboardingBodyPlanSelectorText>
                    <BusinessOnboardingBodyPlanSelectorText bold green>
                      {item?.bestValue && 'Best Value'}
                    </BusinessOnboardingBodyPlanSelectorText>
                  </div>
                )}
              </div>
            </BusinessOnboardingSingleSelectOption>
          ))}
        </BusinessOnboardingSingleSelectOptionsContainer>
      </Popover>
    </>
  )
}
